module.exports = __webpack_public_path__ + "img/twbg_bg.f503314c.png";